module.exports = __webpack_public_path__ + "img/icon_img_11.082a56c9.png";